import {
  ProductDetailsHeaderLarge,
  ProductDetailsHeaderSmall,
} from './components';

export const ProductDetailsHeader = {
  Small: ProductDetailsHeaderSmall,
  Large: ProductDetailsHeaderLarge,
};
